import { render, staticRenderFns } from "./detailsEdit.vue?vue&type=template&id=5d3ff9db&scoped=true&"
import script from "./detailsEdit.vue?vue&type=script&lang=js&"
export * from "./detailsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3ff9db",
  null
  
)

export default component.exports